var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "PickingInfo",
    },
    [
      _c(
        "div",
        { staticClass: "PickingInfo__top" },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 3 } },
            [
              _c("el-descriptions-item", { attrs: { label: "系统单号" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.rsys) + " "),
              ]),
              _c("el-descriptions-item", { attrs: { label: "检索单号" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.sretrieval) + " "),
              ]),
              _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.rorder) + " "),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-descriptions",
            { attrs: { column: 2 } },
            [
              _c("el-descriptions-item", { attrs: { label: "出货门店" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.sstore) + " "),
              ]),
              _c("el-descriptions-item", { attrs: { label: "门店地址" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.sstoreAddr) + " "),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-descriptions",
            { attrs: { column: 2 } },
            [
              _c("el-descriptions-item", { attrs: { label: "顾客地址" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.ccustomerAddr) + " "),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "订单渠道" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        disabled: true,
                        size: "mini",
                      },
                      model: {
                        value: _vm.pickingInfo.rchannel,
                        callback: function ($$v) {
                          _vm.$set(_vm.pickingInfo, "rchannel", $$v)
                        },
                        expression: "pickingInfo.rchannel",
                      },
                    },
                    _vm._l(_vm.channelOptions, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 2 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "单据状态" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.pickingInfo.zstate === 3 ? "已出库" : "已核销"
                        ) +
                        " "
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "单据备注" } }, [
                    _vm._v(" " + _vm._s(_vm.pickingInfo.cremark) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "w200 flex",
                  staticStyle: { "justify-content": "flex-end" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.deviceDialogVisible = true
                        },
                      },
                    },
                    [_vm._v("门店智控")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-descriptions",
            { attrs: { column: 4 } },
            [
              _c("el-descriptions-item", { attrs: { label: "制单人" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.screate) + " "),
              ]),
              _c("el-descriptions-item", { attrs: { label: "制单时间" } }, [
                _vm._v(
                  " " + _vm._s(_vm._f("time")(_vm.pickingInfo.tcreate)) + " "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
                _vm._v(" " + _vm._s(_vm.pickingInfo.saudit) + " "),
              ]),
              _c("el-descriptions-item", { attrs: { label: "审核时间" } }, [
                _vm._v(
                  " " + _vm._s(_vm._f("time")(_vm.pickingInfo.taudit)) + " "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "h450" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.tableData,
                height: "450",
                "row-class-name": _vm.formatRow,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  align: "center",
                  width: "50",
                  selectable: _vm.checkSelectable,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  align: "center",
                  width: "50",
                  type: "index",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "SKU",
                  align: "center",
                  width: "70",
                  prop: "csku",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "图片", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cmasterUrl != null
                          ? _c("el-image", {
                              staticClass: "w50 h50",
                              attrs: {
                                "preview-src-list": [scope.row.cmasterUrl],
                                src: scope.row.cmasterUrl,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货品编码",
                  align: "center",
                  width: "130",
                  prop: "cbarcode",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "货品名称", align: "center", prop: "sgoods" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单位",
                  align: "center",
                  width: "70",
                  prop: "sunit",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单价",
                  align: "center",
                  width: "100",
                  prop: "nprice",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.nprice
                          ? _c("div", [
                              _vm._v("￥ " + _vm._s(scope.row.nprice)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "库位",
                  align: "center",
                  width: "70",
                  prop: "zinventory",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "hHP wHP flex marginLeft10",
                            staticStyle: { "white-space": "break-spaces" },
                          },
                          [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleTakeoff(
                                      scope.row.rinventory
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.zinventory))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "数量", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.num > 1
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(scope.row.nout)),
                            ])
                          : _c("span", [_vm._v(_vm._s(scope.row.nout))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "原库存",
                  align: "center",
                  width: "70",
                  prop: "noldSurplus",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.noldSurplus + scope.row.nout) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.pickingInfo.zstate === 2
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      fixed: "right",
                      width: "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "red",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleShowSurplusDialog(
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v("校正库存")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2147103272
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex alignItemsCenter marginTop10",
          staticStyle: { "justify-content": "space-between", flex: "1" },
        },
        [
          _c("div", [
            _vm._v(" 共计 "),
            _c("span", { staticClass: "blue" }, [
              _vm._v(_vm._s(_vm.tableData.length) + "种"),
            ]),
            _vm._v(" 货品 "),
          ]),
          _c(
            "div",
            [
              _vm.pickingInfo.zstate === 3 || _vm.pickingInfo.zstate === 5
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.checkDestroy },
                    },
                    [_vm._v("核销")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.deviceDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "elDialog",
              attrs: {
                "close-on-click-modal": false,
                title: "查看门店智控",
                visible: _vm.deviceDialogVisible,
                width: "400px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.deviceDialogVisible = $event
                },
              },
            },
            [_c("deviceControl", { attrs: { "store-info": _vm.storeInfo } })],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "库存校正",
            visible: _vm.surplusDialog,
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.surplusDialog = $event
            },
          },
        },
        [
          _c("surplusSheet", {
            attrs: { "picking-detail": _vm.pickingDetail },
            on: {
              handleSubmit: _vm.handleSurplusSheetSubmit,
              handleClose: _vm.handleClose,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }